// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"r140J","hidden":"zkC4u","title":"d9hEX","link":"_1fXAP"};